import { DOG_LIABILITY_NXT_CONSTANTS } from '@flows/configs/dogLiabilityNxt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_DogLiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const dog_sos_help = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('sos_help_coverage')]:
        BaseSchema_DogLiabilityV1GetsafeDe.shape.sos_help_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.title',
        },
        infoButton: {
          modalConfiguration: [
            {
              type: 'title',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.title1',
              },
            },
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.text1',
              },
            },
            {
              type: 'title',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.title2',
              },
            },
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.text2',
              },
            },
            {
              type: 'title',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.title3',
              },
            },
            {
              type: 'text',
              text: {
                type: 'translatableText',
                translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.modal.text3',
              },
            },
          ],
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('sos_help_coverage'),
        options: DOG_LIABILITY_NXT_CONSTANTS.sosHelpOptions,
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dogLiabilityNxt:steps.sos_help_coverage.infoBox.text',
            },
          },
        ],
      },
    ],
    nextStep: 'dog_quote',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default dog_sos_help
